import { gql } from "@apollo/client";

export const CREATE_GROUP_FEE = gql`
  mutation AddGroupFee($input: GroupFeeInput!) {
    addGroupFee(input: $input) {
      status
      message
    }
  }
`;

export const GET_GROUPFEE_PAGINATION = gql`
  query GetGroupFeePagination($page: Int!, $limit: Int!, $keyword: String) {
  getGroupFeePagination(page: $page, limit: $limit, keyword: $keyword) {
    data {
      _id
      groupFeeName
      academicYearCost
      academicTermCost
      quarterCost
      monthCost
      incomeType
      note
      shiftId
      shiftName
      classGroupName
      classGroupId
      programId
      programName
    }
    paginator {
      slNo
      prev
      next
      perPage
      totalPosts
      totalPages
      currentPage
      hasPrevPage
      hasNextPage
      totalDocs
    }
  }
}
`;

export const UPDATE_GROUP_FEE = gql`
  mutation UpdateGroupFee($id: ID!, $input: GroupFeeInput!) {
    updateGroupFee(_id: $id, input: $input) {
      status
      message
    }
  }
`;

export const DELETE_GROUP_FEE = gql`
  mutation DeleteGroupFee($id: ID!) {
    deleteGroupFee(_id: $id) {
      status
      message
    }
  }
`;
